export default "Le TURPE représente jusqu'à un tiers de votre facture d'électricité pro. Puissances souscrites, formule tarifaire, dépassements : audit gratuit de vos leviers d'économies, sans changer de fournisseur.";
